import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"image-carousel"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3H3V17H21V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 13.3636L8.29412 9L18 17H3V13.3636Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M17.5556 7.77778C17.5556 8.75962 16.7596 9.55556 15.7778 9.55556C14.7959 9.55556 14 8.75962 14 7.77778C14 6.79594 14.7959 6 15.7778 6C16.7596 6 17.5556 6.79594 17.5556 7.77778Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 13.7273V13.3636L8.29412 9L18 17M3 3H21V17H3V3ZM17.5556 7.77778C17.5556 8.75962 16.7596 9.55556 15.7778 9.55556C14.7959 9.55556 14 8.75962 14 7.77778C14 6.79594 14.7959 6 15.7778 6C16.7596 6 17.5556 6.79594 17.5556 7.77778Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 21H6M10 21H14M18 21L21 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ImageCarousel = Vue.extend<IconProps>({
  name: 'ImageCarouselIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'image-carousel',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ImageCarousel;
